import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD2a_mUrH42s0pnlIGUfNGBCkrvW4ieXsA",
  authDomain: "portfolio-austin-han.firebaseapp.com",
  projectId: "portfolio-austin-han",
  storageBucket: "portfolio-austin-han.firebasestorage.app",
  messagingSenderId: "223347795258",
  appId: "1:223347795258:web:6d70f41e630c91f0cc5c03",
  measurementId: "G-MQ5CK2JPJ1",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
